<a routerLink="{{ place.url }}" queryParamsHandling="preserve">
  <div class="card place-box">

    <!-- Heart -->
    <a href="#" (click)="toggleLike(); $event.preventDefault(); $event.stopImmediatePropagation(); $event.stopPropagation()" *ngIf="currentUser && showLikeButton">
      <div class="heart" [class]="{ 'heart-on': place.likes!.indexOf(currentUser._id!) >= 0, 'heart-off': place.likes!.indexOf(currentUser._id!) == -1 }">
      </div>
    </a>

    <!-- Availability -->
    <div class="availability-overlay">
      <span class="badge" *ngIf="reservableSeats">{{ reservableSeats }} seat{{ reservableSeats ? '' : 's' }} available</span>
      <span class="badge" *ngIf="!reservableSeats">{{ place.status }}</span>
    </div>

    <div class="card-space">
      <img [src]="place.smallImages!.length > 0 ? place.smallImages![0].filePath! : '/images/discover/place-box/place-default.jpg'" [alt]="place.name" class="img-responsive"/>
    </div>

    <div class="card-body">
      <div class="card-title">
        <h4>{{ place.name }}</h4>
      </div>

      <div class="card-subtitle">
        <div>
          <!--          <span class="place-visible" *ngIf="place.visible">&#9679;</span>-->
          <!--          <span class="place-invisible" *ngIf="!place.visible">&#9724;</span>-->
          <small> {{ place.location?.neighborhood }}</small>
        </div>
        <div>
          <!--          <small>{{ place.location!.address }} - {{ place.location!.neighborhood }}</small>-->
          <!--          <small>{{ place.status }}</small>-->
        </div>
      </div>
    </div>
  </div>
</a>

<!--  <div class="card-space" [ngStyle]="{'min-height': minHeightPx ? minHeightPx + 'px' : '' }">-->
<!--    <div class="availability">-->
<!--      <span class="badge circular" *ngIf="(filter$ | async)?.isScheduleSearch" [ngStyle]="{ 'font-size.px': fontSizeMedium }"-->
<!--      >{{ place?.availableReserveSeats?.length }} seat{{ place?.availableReserveSeats?.length === 1 ? '' : 's' }} available</span-->
<!--      >-->
<!--      <span class="badge circular" *ngIf="!((filter$ | async)?.isScheduleSearch)" [ngStyle]="{ 'font-size.px': fontSizeMedium }">{{ place?.status }}</span>-->
<!--    </div>-->
<!--    <img-->
<!--      [ngClass]="{-->
<!--        grey:-->
<!--          !((filter$ | async)?.isScheduleSearch) &&-->
<!--          currentUser &&-->
<!--          (place?.availableSeats?.length === 0 ||-->
<!--            !(currentUser ? (currentUser?.verification ? place?.isVerifiedOpen : place?.isOpen) : place?.isOpen))-->
<!--      }"-->
<!--      [src]="place?.smallImages?.length > 0 ? place.smallImages[0].filePath : '/assets/images/discover/place-place-default.jpg'"-->
<!--      [alt]="(place?.smallImages)[0]?.description"-->
<!--    />-->
<!--  </div>-->
<!--  <div class="card-header" *ngIf="!moreInfo">-->
<!--    <div class="card-title circular" [ngStyle]="{ 'font-size.px': fontSizeLarge }">{{ place?.name }}</div>-->
<!--    <div class="card-subtitle circular" [ngStyle]="{ 'font-size.px': fontSizeSmall }" *ngIf="!showHours">-->
<!--      {{ place?.location?.neighborhood }}-->
<!--      <span class="distance" *ngIf="place?.distance && place?.distance < 10">-->
<!--        • {{ place?.distance | number: (place?.distance < 10 ? '1' : '0') }} miles</span-->
<!--      >-->
<!--    </div>-->
<!--    <div class="card-subtitle circular" [ngStyle]="{ 'font-size.px': fontSizeSmall }" style="font-weight: 300;" *ngIf="showHours">-->
<!--      {{ place?.hoursOfOperation }}-->
<!--    </div>-->
<!--  </div>-->
